import { HttpErrorResponse } from '@angular/common/http';

/**
 * Mensaje comprensible y seguro para un fallo al cargar una entidad (sin detalles internos). Sustituye a
 * `err.error.status.message`, que lanzaba un TypeError cuando la respuesta no traía cuerpo (403 sin cuerpo, red caída, 502…).
 */
export function mensajeErrorCarga(err: unknown, entidad: string): string {
  const e = err as HttpErrorResponse | undefined;
  if (e?.status === 404) return `${entidad[0].toUpperCase()}${entidad.slice(1)} no existe.`;
  if (e?.status === 403) return `No tienes permiso para ver ${entidad === 'la asociación' ? 'esta asociación' : 'este elemento'}.`;
  if (e?.status === 401) return 'Tu sesión ha caducado. Vuelve a iniciar sesión.';
  if (e?.status === 0) return 'No se ha podido conectar con el servidor. Comprueba la conexión e inténtalo de nuevo.';
  const detalle = e?.error?.status?.message;
  return 'Se produjo un error al cargar los datos' + (detalle ? ': ' + detalle : '.');
}

/** Mensaje de un fallo al guardar o ejecutar una acción. */
export function mensajeErrorAccion(err: unknown, porDefecto: string): string {
  const e = err as HttpErrorResponse | undefined;
  if (e?.status === 403) return 'No tienes permiso para realizar esta acción.';
  if (e?.status === 401) return 'Tu sesión ha caducado. Vuelve a iniciar sesión.';
  return e?.error?.status?.message || e?.error?.message || porDefecto;
}
